import { Component } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { EndpointSpecificFaultCode, Fault, FaultCode } from 'src/app/_models';
import { CacheService } from 'src/app/_services';
import { LoadingComponent } from '../email-verification/_states/loading/loading.component';
import { VerifiedComponent } from '../email-verification/_states/verified/verified.component';
import { ErrorComponent, EmailVerificationError } from '../email-verification/_states/error/error.component';

enum OrganizationEmailVerificationState {
  Loading = 'Loading',
  Verified = 'Verified',
  Error = 'Error',
}

@Component({
  selector: 'app-organization-email-verification',
  standalone: true,
  imports: [LoadingComponent, VerifiedComponent, ErrorComponent, RouterLink],
  templateUrl: './organization-email-verification.component.html',
})
export class OrganizationEmailVerificationComponent {
  readonly organizationScope = 'organizationEmailVerification';

  email = '';
  token = '';
  state: OrganizationEmailVerificationState = OrganizationEmailVerificationState.Loading;
  error: EmailVerificationError | null = null;

  OrganizationEmailVerificationState = OrganizationEmailVerificationState;

  constructor(
    private route: ActivatedRoute,
    private cache: CacheService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.token = this.route.snapshot.params['token'] ?? '';
    this.email = this.route.snapshot.params['email'] ?? '';

    if (!this.token) {
      this.state = OrganizationEmailVerificationState.Error;
      this.error = EmailVerificationError.InvalidToken;
      return;
    }

    if (!this.email) {
      this.state = OrganizationEmailVerificationState.Error;
      this.error = EmailVerificationError.InvalidEmail;
      return;
    }

    try {
      await this.cache.sleep(500);
      await this.cache.verifyCompanyEmailByToken(this.token);
      this.state = OrganizationEmailVerificationState.Verified;
    } catch (err) {
      if (err instanceof Fault) {
        if (err.code === FaultCode.EndpointSpecific && err.inner) {
          switch (err.inner.code) {
            case EndpointSpecificFaultCode.ExistingValidEmail:
              this.state = OrganizationEmailVerificationState.Error;
              this.error = EmailVerificationError.AlreadyVerified;
              return;
            case EndpointSpecificFaultCode.ExpiredToken:
              this.state = OrganizationEmailVerificationState.Error;
              this.error = EmailVerificationError.ExpiredToken;
              return;
            default:
              break;
          }
        }
        this.state = OrganizationEmailVerificationState.Error;
        this.error = EmailVerificationError.InvalidToken;
        return;
      }
      this.state = OrganizationEmailVerificationState.Error;
      this.error = EmailVerificationError.InvalidToken;
    }
  }
}
